import { doc, getDoc } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import CancelationConfirmation from "./CancelationConfirmation";
import { db } from "../../../firebase";

const landingId = "CF_CANCELATION_CONFIRMATION";

const onLoad = async ({ session, landedAt, uid, fieldsStructure }) => {
  const prevAnswers = {};
  const prevForm = await getFormSession("cancelation-form", session.sessionID);
  const landings = prevForm.items;

  landings.forEach((item) => {
    if (item.answers.length > 0) {
      const lastField = item?.answers[0];
      const fieldID = lastField.field.id;
      const lastFieldType = lastField.type;
      const lastFieldAnswers = lastField[lastFieldType]?.value;
      prevAnswers[fieldID] = lastFieldAnswers;
    }
  });

  const productsToCancel = landings[0];
  const productsField = productsToCancel.answers[0];
  const productType = productsField.type;
  const products = productsField[productType].value;

  const devices = ["smartphone", "laptop", "tablet"];
  const isADeviceCheck = (d) => devices.includes(d) || d === "devices";
  const productsData = [];
  if (products.length === 1) {
    const product = products[0];
    const docRef = doc(
      db,
      `users/${uid}/${
        isADeviceCheck(product.type) ? "smartphones" : "vehicles"
      }/${product.id}`
    );
    const docSnap = await getDoc(docRef);
    const docData = docSnap.data();
    productsData.push(docData);
  }

  return {
    userId: uid,
    ...prevAnswers,
    landedAt,
    prevForm,
    isMoreThanOne: products.length > 1,
    products: productsData,
    currentLanding: landingId
  };
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <CancelationConfirmation
    state={state}
    setState={setState}
    field={"CF_cancelation_confirmation_s21yh"}
  /> // Field ID
);

const nextPage = (props) => `/formulario/cancelacion/final?uid=${props.uid}`;

const prevPage = (props) => `/formulario/cancelacion/mejoras?uid=${props.uid}`;

const fieldsStructure = [];

const cancelationConfirmationProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default cancelationConfirmationProps;
